import { kebabCase } from "@/lib/utils";
import Image, { ImageProps } from "next/image";

interface ThemeIllustrationProps extends Omit<ImageProps, "alt" | "src"> {
    theme: string;
    type: "complex" | "simple"
}

export function ThemeIllustration({theme, type, ...props}: ThemeIllustrationProps) {
    const folder = kebabCase(type)
    const file = kebabCase(theme)
    return (
        <Image
            {...props}
            src={`/themes/${folder}/${file}.svg`}
            alt={`${file} ${folder}`}
        />
    )
}